
enum DeliveryPersonType{
    DELIVERY_PERSON = "DELIVERY_PERSON",
    ORGANIZER = "ORGANIZER"
}
export default DeliveryPersonType